import * as React from "react";
import { FunctionComponent } from "react";
import { LogoSize, TranslatedPartnerLogo } from "../types";
import LazyImage from "./LazyImage";
import * as ClassNames from "classnames";

interface Props {
  partnerLogo: TranslatedPartnerLogo;
  size: LogoSize;
  className?: string;
}

const PartnerLogo: FunctionComponent<Props> = ({
  partnerLogo,
  size,
  className,
}) => {
  const {
    translation: { file },
    partner: {
      translation: { origin, url, name },
    },
  } = partnerLogo;

  const href = origin + url;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener"
      className={ClassNames("PartnerLogo", `PartnerLogo--${size}`, className)}
    >
      <LazyImage src={file} alt={name} />
    </a>
  );
};

export default PartnerLogo;
